import { useQuery } from '@tanstack/react-query';

import { getUnviewedBackInStockWaitlistFulfillments } from 'api/jalapeno';

import useAccountQuery from './useAccountQuery';

export const UNVIEWED_BACK_IN_STOCK_WAITLIST_FULFILLMENTS_QUERY_KEY = 'unviewed-back-in-stock-waitlist-fulfillments';

const useUnviewedBackInStockWaitlistFulfillmentsQuery = ({ queryProps } = {}) => {
    const { data: account } = useAccountQuery();
    const { chargeID } = account?.nextOrder ?? {};
    const { enabled: queryEnabled = true, ...restQueryProps } = queryProps ?? {};

    return useQuery({
        queryKey: [UNVIEWED_BACK_IN_STOCK_WAITLIST_FULFILLMENTS_QUERY_KEY, chargeID],
        queryFn: async () => {
            const response = await getUnviewedBackInStockWaitlistFulfillments(chargeID);
            return response?.data ?? {};
        },
        enabled: !!chargeID && queryEnabled,
        ...restQueryProps,
    });
};

export default useUnviewedBackInStockWaitlistFulfillmentsQuery;
